import { render, staticRenderFns } from "./BoletaEmision.vue?vue&type=template&id=2b38c227&scoped=true&"
import script from "./BoletaEmision.vue?vue&type=script&lang=js&"
export * from "./BoletaEmision.vue?vue&type=script&lang=js&"
import style0 from "./BoletaEmision.vue?vue&type=style&index=0&id=2b38c227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38c227",
  null
  
)

export default component.exports